
import React, { useState, useContext } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { FaRegEdit } from 'react-icons/fa';
import { MdOutlineDelete } from 'react-icons/md';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import PageLoader from '../components/PageLoader';
import AddVersionModal from '../components/Modal/AddVersionModal';
import DeleteVersionModal from '../components/Modal/DeleteVersionModal';
import AddReleaseNoteModal from '../components/Modal/AddReleaseNoteModal';
import { UserContext } from '../contexts/UserContext';
import useGetCurrentVersion from '../services/useGetCurrentVersion';
import useDeleteVersion from '../services/useDeleteVersion';
const allowedEmails = [
    'mmorgenstern@srxltc.com',
    'sengelman@srxltc.com',
    'droque@srxltc.com',
    'sansari@srxltc.com',
];

function Versions() {
    const { user } = useContext(UserContext);

    const allowedUsers = allowedEmails.includes(
        user?.email?.toLowerCase()
    );

    const { deleteVersion, isDeleteVersionLoading } = useDeleteVersion();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedVersion, setSelectedVersion] = useState(null);
    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);
    const { currentVersion, isCurrentVersionLoading } = useGetCurrentVersion();
    const [isModalOpenReleaseModal, setIsModalOpenReleaseModal] = useState(false);
    const version = currentVersion?.version;

    const handleDeleteVersion = () => {
        if (!version?.id) {
            toast.error('Version ID missing');
            return;
        }
        deleteVersion(
            { id: version.id },
            { onSuccess: () => setIsDeleteModalOpen(false) }
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return dateString.split("T")[0];
    };

    if (isCurrentVersionLoading) return <PageLoader />;

    return (
        <>
            <Row className="p-2">
                <Col>
                    <h2>Specialty365 Versions</h2>
                </Col>
                <Col className="text-right">
                {allowedUsers && (
                        <button
                            className="btn btn-primary "
                            onClick={() => {
                                setSelectedVersion(null);
                                setIsModalOpen(true);
                            }}
                        >
                            Add Version
                        </button>
                    )}
                    <Link to="/info/view-all-versions">
                        <button
                            className="btn btn-primary ml-2"
                        >
                            View Previous Versions
                        </button>
                    </Link>
                </Col>
            </Row>
            {currentVersion?.version && (
                <Row className="justify-content-center mt-3">
                    <Col md={10} lg={10} xl={8}>
                        <Card className="ribbon-box">
                            <CardBody>
                                <div className="float-left">
                                    <div className={classNames('ribbon-two', 'ribbon-two-primary')}>
                                        <span>{version.version}</span>
                                    </div>
                                </div>

                                <div
                                    className="d-flex justify-content-end align-items-center mb-2"
                                    style={{ gap: '8px' }}
                                >
                                    <h5 className='mr-2'>
                                        Version {version.version} - {version.title}
                                    </h5>
                                    {allowedUsers && (
                                        <div className="d-flex align-items-center ">
                                            <div
                                                onClick={() => {
                                                    setSelectedVersion(currentVersion);
                                                    setIsModalOpen(true);
                                                }}
                                                className='mr-1'
                                                title="Edit Version"
                                                style={{
                                                    padding: '6px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#28a745',
                                                    color: '#fff',
                                                    borderRadius: '50%',
                                                    width: '30px',
                                                    height: '30px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.15)';
                                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                                                }}
                                            >
                                                <FaRegEdit size={16} />
                                            </div>
                                            <div
                                                onClick={() => setIsDeleteModalOpen(true)}
                                                title="Delete Version"
                                                style={{
                                                    padding: '6px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#dc3545',
                                                    color: '#fff',
                                                    borderRadius: '50%',
                                                    width: '30px',
                                                    height: '30px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.15)';
                                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                                                }}
                                            >
                                                <MdOutlineDelete size={20} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="ribbon-content">
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(version.description),
                                        }}
                                    />
                                </div>
                                {version.pharmUserDescription && (
                                    <>
                                        <hr />
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    '<b>Admin Update:</b><br />' + version.pharmUserDescription
                                                ),
                                            }}
                                        />
                                    </>
                                )}
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="text-muted">
                                        {formatDate(version.date)} — By {version.author}
                                    </div>
                                    {allowedUsers && (
                                        <button className="btn btn-primary" onClick={() => setIsModalOpenReleaseModal(true)}>
                                            Add Release Note
                                        </button>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
            {version && <ReleaseNotesSection
                currentReleaseNotes={currentVersion?.releaseNotes}
                formatDate={formatDate}
                setIsVersionModalOpen={setIsModalOpen}
                isCurrentVersionLoading={isCurrentVersionLoading}
                versionId={version.id}
                setIsModalOpenReleaseModal={setIsModalOpenReleaseModal}
                isModalOpenReleaseModal={isModalOpenReleaseModal} />
            }
            <AddVersionModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                toggle={toggleModal}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
            />
            <DeleteVersionModal
                isModalOpen={isDeleteModalOpen}
                setIsModalOpen={setIsDeleteModalOpen}
                toggle={toggleDeleteModal}
                versionToDelete={currentVersion?.version}
                onConfirmDelete={handleDeleteVersion}
                isDeleting={isDeleteVersionLoading}
            />
        </>
    );
}
export default Versions;


function ReleaseNotesSection({
    currentReleaseNotes,
    formatDate,
    setIsVersionModalOpen,
    isCurrentVersionLoading,
    setIsModalOpenReleaseModal,
    isModalOpenReleaseModal,
    versionId }) {
    const { user } = useContext(UserContext);

    const [selectedReleaseNote, setSelectedReleaseNote] = useState(null);

    return (
        <>
            <Row className="justify-content-center mt-4">
                <Col md={10} lg={10} xl={8}>
                    {/* Header */}
                    {(!currentReleaseNotes || currentReleaseNotes?.length > 0) && (
                        <div className="d-flex justify-content-between mb-2">
                            <h4>Release Notes</h4>
                        </div>
                    )}

                    {/* Loader */}
                    {isCurrentVersionLoading ? (
                        <div className="text-center my-4">
                            <PageLoader />
                        </div>
                    ) : (
                        <>
                            {currentReleaseNotes
                                ?.filter(note =>
                                    !note.pharmUserOnly ? true : user?.userType === 'PharmacyUser'
                                )
                                .map(note => (
                                    <Card key={note.id} className="ribbon-box mb-3">
                                        <CardBody>
                                            <div
                                                className={classNames(
                                                    'ribbon',
                                                    'ribbon-primary',
                                                    'mb-0',
                                                    'float-left'
                                                )}
                                            >
                                                <i className="mdi mdi-balloon mr-1"></i> {note.type} - ID: {note.id}
                                            </div>
                                            <div
                                                className="d-flex justify-content-end align-items-center mb-2"
                                                style={{ gap: '8px' }}
                                            >
                                                <h5 className="mr-2">{note.title}</h5>
                                            </div>
                                            <div className="ribbon-content">
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(note.description),
                                                    }}
                                                />
                                            </div>
                                            <hr />
                                            <div className="text-muted">
                                                {formatDate(note.date)} — By {note.author}
                                            </div>
                                        </CardBody>
                                    </Card>
                                ))}
                        </>
                    )}
                </Col>
            </Row>
            <AddReleaseNoteModal
                isModalOpen={isModalOpenReleaseModal}
                setIsModalOpen={setIsModalOpenReleaseModal}
                selectedReleaseNote={selectedReleaseNote}
                setSelectedReleaseNote={setSelectedReleaseNote}
                versionId={versionId}
                handleCloseVersionModal={() => setIsVersionModalOpen(false)}

            />

        </>
    );
}


